import { render, staticRenderFns } from "./RefundDetailTab.vue?vue&type=template&id=101a1af9&scoped=true"
import script from "./RefundDetailTab.vue?vue&type=script&lang=js"
export * from "./RefundDetailTab.vue?vue&type=script&lang=js"
import style0 from "./RefundDetailTab.vue?vue&type=style&index=0&id=101a1af9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a1af9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('101a1af9')) {
      api.createRecord('101a1af9', component.options)
    } else {
      api.reload('101a1af9', component.options)
    }
    module.hot.accept("./RefundDetailTab.vue?vue&type=template&id=101a1af9&scoped=true", function () {
      api.rerender('101a1af9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/booking/RefundDetailTab.vue"
export default component.exports